import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/utils/cn';

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  showBack?: boolean;
  onBack?: () => void;
  className?: string;
}

function PageHeader({
  title,
  description,
  action,
  showBack = false,
  onBack,
  className,
}: PageHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={cn('mb-8', className)}>
      {showBack && (
        <button
          onClick={handleBack}
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            color: 'var(--color-text-secondary)',
            marginBottom: '16px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            transition: 'color 120ms ease',
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.color = 'var(--color-text-primary)';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.color = 'var(--color-text-secondary)';
          }}
        >
          <ArrowLeftIcon style={{ width: '16px', height: '16px', marginRight: '8px' }} />
          Back
        </button>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex-1">
          <h1
            style={{
              /* PT-3: editorial serif page title (Fraunces ruling). 'Sora' was
                 never loaded — it silently fell back to sans. */
              fontFamily: 'var(--font-editorial)',
              fontWeight: 400,
              fontSize: '30px',
              letterSpacing: '-0.01em',
              color: 'var(--color-text-primary)',
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            {title}
          </h1>
          {description && (
            <p
              style={{
                marginTop: '8px',
                fontSize: '14px',
                color: 'var(--color-text-secondary)',
              }}
            >
              {description}
            </p>
          )}
        </div>
        {action && (
          <div
            className="flex-shrink-0"
            style={{
              display: 'block',
              visibility: 'visible',
              opacity: 1,
              zIndex: 10,
              minWidth: 'fit-content',
            }}
          >
            {action}
          </div>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
